import Query from "./query";

class IsVRConnected extends Query {
    constructor() {
        super("isVRConnected");
    }

    async execute(params) {
        return await isVRConnected();
    }
}

export default IsVRConnected;